/**
 * Mock implementation for the story PDF export endpoint.
 *
 * Mirrors the live exportStoryPdf() signature exactly — swap to live by
 * setting REACT_APP_STORY_EXPORT_API=live (or removing the isMock() branch).
 *
 * In mock mode the "download URL" is a local object URL created from the
 * generated PDF blob, so the file opens in a new tab without a real server.
 */
import type { PdfExportResponse } from "./storyExport.types";

export async function mockExportStoryPdf(
  _workspaceId: string,
  _storyId: string,
  file: File,
): Promise<PdfExportResponse> {
  await new Promise((r) => setTimeout(r, 800));
  return {
    artifact_id: "mock-artifact-001",
    format: "pdf",
    download_url: URL.createObjectURL(file),
    generated_at: new Date().toISOString(),
  };
}
